// src/components/VerticalLayout/index.js
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import withRouter from "components/Common/withRouter";
import {
  showHeaderAction,
  showFooterAction,
  showRightSidebarAction,

  changeLayout,
  changeLayoutMode,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions";

import { selectLayoutSettings } from "../../store/selectors";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import MobileBottomBar from "./MobileBottomBar";
import RightSidebar from "../CommonForBoth/RightSidebar";

import useIsMobile from "hooks/useIsMobile";

//redux
import { useSelector, useDispatch } from "react-redux";

/*
function useIsMobile() {
  const getIsMobile = () =>
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 769;

  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}
*/

const Layout = props => {
  const dispatch = useDispatch();

  const {
    showHeader,
    showFooter,
    showRightSidebar,

    isPreloader,
    leftSideBarThemeImage,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    leftSideBarTheme,
    layoutModeType,
  } = useSelector(selectLayoutSettings);

  // TEMP TEST: log everything inside your component
  // See what is in localStorage
  // console.log(JSON.parse(localStorage.getItem('persist:root') ?? '{}'));

  //const fullState = useSelector(state => state);
  //console.log('Redux full state:', fullState);

  //const layout = useSelector((state) => state.Layout);
  //console.log('layout state:', layout); // check if showHeader exists

  //const showHeader = useSelector((state) => state.Layout.showHeader);
  //console.log('Direct showHeader:', showHeader); // if this works, the selector is the issue
  

  const isMobile = useIsMobile();
  //console.log('isMobile:', isMobile);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };

  //hides right sidebar on body click
  const hideRightbar = (event) => {
    var rightbar = document.getElementById("right-bar");
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return;
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false));
    }
  };

  /*
  layout  settings
  */

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);

  useEffect(() => {
    if (leftSideBarThemeImage) {
      dispatch(changeSidebarThemeImage(leftSideBarThemeImage));
    }
  }, [leftSideBarThemeImage, dispatch]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType));
    }
  }, [leftSideBarType, dispatch]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);

  useEffect(() => {
    //console.log('!!!showFooter:', showFooter);
  }, [showFooter]);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        {!isMobile && showHeader && <Header toggleMenuCallback={toggleMenuCallback} />}
        {!isMobile && <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />}
        <div className={`main-content${isMobile ? " mobile-layout-no-header" : ""}`}> 
          {props.children}
        </div>
        {showFooter && <Footer />}
      </div>
      {isMobile && <MobileBottomBar />}
      {showRightSidebar ? <RightSidebar /> : null}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default withRouter(Layout);
